import React from "react";

class RechargeDeviceBanner extends React.Component {
  render() {
    return (
        <section className="header_section header_section_recharge">
          {/* <div className="bg-overlay" / >*/}
          <div className="container">
            <div className="row">

              <div className="col-lg-7">
                <div className="desktop-header">
                  <h5 className="mb-2 SansSerif bold600">New Generation of Global Wifi</h5>
                  <h1 className="sub no-margin bold600 mb-3">MightyWifi Cloud</h1>
                  <div className="col-md-12" style={{ clear: "both", height: "20px" }} />
                  <div className="row">
                    <div className="col-md-6">
                      <div className="row">
                        <div className="col-md-3">
                          <div className="icon-box">
                            <div className="icon ai"></div>
                          </div>
                        </div>
                        <div className="col-md-9 icon-text-box">
                          <strong className="icon-text">Thin and Light to Carry<br/><span className="bold400">Pocket size 5.4*2.8*0.5 Inch, 5.40 oz.</span></strong>
                        </div>

                        <div className="col-md-12" style={{ clear: "both", height: "20px" }} />

                        <div className="col-md-3">
                          <div className="icon-box">
                            <div className="icon check"></div>
                          </div>
                        </div>
                        <div className="col-md-9 icon-text-box">
                          <strong className="icon-text">Slim Design<br/><span className="bold400">2.0 Inch screen with easy navigation</span></strong>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="row">
                        <div className="col-md-3">
                          <div className="icon-box">
                            <div className="icon unlimited"></div>
                          </div>
                        </div>
                        <div className="col-md-9 icon-text-box">
                          <strong className="icon-text">Fast Charging<br/><span className="bold400">USB Type C Cable, less than an hour for full charge</span></strong>
                        </div>

                        <div className="col-md-12" style={{ clear: "both", height: "20px" }} />

                        <div className="col-md-3">
                          <div className="icon-box">
                            <div className="icon battery"></div>
                          </div>
                        </div>
                        <div className="col-md-9 icon-text-box">
                          <strong className="icon-text">13 Continuous Working Hour<br/><span className="bold400">3600mAh, lithium battery, Non removal</span></strong>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-5"></div>


              {/*
                <div className="mobile-header">
                  <h2 className="SansSerif bold600 m-title-positon">
                    <span className="line-break m-header-mtitle Serif">Coming Soon</span>
                    <span className="line-break m-header-stitle">2ND generation of global wifi hotspot</span>
                    MightyWifi Cloud
                  </h2>
                </div>
                */}

            </div>
          </div>
          <div id="RechargeSection"></div>
        </section>
    );
  }
}

export default RechargeDeviceBanner;



// WEBPACK FOOTER //
// ./src/reusable/RechargeDeviceBanner.js